module.exports = __webpack_public_path__ + "static/rafael-60f4350a6efeb95752a9047bc225bb8d.jpg";